var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolicitor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.21 222.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d,.e,.f,.g,.h,.i,.j,.k{stroke-linecap:round;}.d,.e,.f,.h,.i,.j,.k{stroke-linejoin:round;stroke-width:7px;}.d,.l,.i{fill:#fff;}.d,.g{stroke:#fff;}.e{stroke:#99c5ff;}.e,.h,.k{fill:none;}.f,.g{fill:#5da8f6;}.f,.i,.j,.k{stroke:#386aff;}.g{stroke-miterlimit:10;stroke-width:3px;}.h{stroke:#5da8f6;}.j{fill:#99c5ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M35.79,93.19c0,34.81,29.63,63.03,56.31,63.03s56.31-28.22,56.31-63.03-14.16-66.63-56.31-66.63-56.31,31.82-56.31,66.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M84.56,191.07c-6.07,0-11.91-2.42-16.2-6.71s-6.71-10.13-6.71-16.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M83.47,206c-9.75,0-19.1-3.88-26-10.77-6.89-6.89-10.77-16.25-10.77-26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M82.81,219.21c-13.07,0-25.62-5.2-34.87-14.44-9.24-9.24-14.44-21.8-14.44-34.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M167.85,73.4h-10c-1.93,0-3.5,1.57-3.5,3.5v23.01c0,32.93,0,49.79-47.82,54.23-2.58-3.37-6.59-5.39-10.92-5.39h-12.53c-7.6,0-13.78,6.18-13.78,13.78v1.67c0,7.6,6.18,13.78,13.78,13.78h12.53c4.93,0,9.46-2.69,11.91-6.87,25.24-2.25,42.34-9.82,52.21-23.09,10.76-14.46,11.62-25.7,11.62-48.12v-23.01c0-1.93-1.57-3.5-3.5-3.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 83.23,
    y: 151.82,
    width: 12.24,
    height: 23.09,
    rx: 5.28,
    ry: 5.28,
    transform: "translate(-74.02 252.71) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M19.57,126.72v-5.26h-4.22c-6.53,0-11.85-5.31-11.85-11.85v-21.94c0-6.53,5.31-11.85,11.85-11.85h4.22v-5.26h18.47v56.16H19.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M146.17,126.72v-56.16h18.47v5.26h4.22c6.53,0,11.85,5.31,11.85,11.85v21.94c0,6.53-5.31,11.85-11.85,11.85h-4.22v5.26h-18.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M18.6,83.03v-6.02C18.6,36.4,51.55,3.5,92.1,3.5s73.5,32.9,73.5,73.5v6.02"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M155.4,76.9v23.01c0,39.57,5.45,63.46-66.06,63.46"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 83.23,
    y: 151.82,
    width: 12.24,
    height: 23.09,
    rx: 5.28,
    ry: 5.28,
    transform: "translate(-74.02 252.71) rotate(-90)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M16.18,80.32h7.88v36.65h-7.88c-4.52,0-8.18-3.67-8.18-8.18v-20.28c0-4.52,3.67-8.18,8.18-8.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    x: 24.06,
    y: 75.05,
    width: 9.49,
    height: 47.18
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M168.33,80.32h7.88v36.65h-7.88c-4.52,0-8.18-3.67-8.18-8.18v-20.28c0-4.52,3.67-8.18,8.18-8.18Z",
    transform: "translate(336.36 197.28) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    x: 150.66,
    y: 75.05,
    width: 9.49,
    height: 47.18,
    transform: "translate(310.81 197.28) rotate(-180)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolicitor);
export default __webpack_public_path__ + "static/media/solicitor.f26825b68bcbd57b1013ceca0491d8dd.svg";
export { ForwardRef as ReactComponent };